// @ts-nocheck
/* eslint-disable */
import React from 'react';
import './index.scss';

function Welcome() {
  return (
    <div className="welcome">
      <div className="welcome-content">
        <h1 className="welcome-title">欢迎登录管理后台</h1>
        <h3 className="welcome-subtitle">请选择一个模块进行操作</h3>
      </div>
    </div>
  );
}

export default Welcome;

